import { ErrorBoundary } from "react-error-boundary";

import { ErrorFallback } from "./ErrorBoundaryEmptyState";

interface IDefaultErrorBoundaryProps {
    children: React.ReactNode;
}

export const DefaultErrorBoundary = ({ children }: IDefaultErrorBoundaryProps) => (
    <ErrorBoundary FallbackComponent={ErrorFallback}>{children}</ErrorBoundary>
);
